import Swiper from 'swiper/bundle';
import {
    sameHeight,
} from '@js/common/all-functions.js';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const tallCard = document.querySelectorAll('.tall-card-section');
    sameHeight('.tall-card-section .card-title');

    tallCard.forEach(section => {
        const cardSldier = section.querySelector('.tall-card-slider'); // Make sure to scope this to each section

        new Swiper(cardSldier, {
            slidesPerView: 1.23,
            spaceBetween: 24,
            navigation: {
                prevEl: section.querySelector('.tcs-arrow-prev'),
                nextEl: section.querySelector('.tcs-arrow-next'),
            },
            breakpoints: {
                576: {
                    slidesPerView: 2.08,
                },
                992: {
                    slidesPerView: 3.08,
                },
                1200: {
                    slidesPerView: 4.08,
                },
            },
        });
    });
});
